import { Link } from "react-router-dom";

const LinkButton = ({
	to,
	label,
	text,
	labelStyle,
	textClassName,
	textStyle
}: any) => {
	return (
		<div style={labelStyle}>
			{label}&nbsp;
			<Link
				to={to}
				className={textClassName}
				style={{ ...textStyle, textDecoration: "none" }}
			>
				{text}
			</Link>
		</div>
	);
};

export default LinkButton;
